import React from "react";
import { InsBy } from "../../common/common";

import { InsuranceBlack, InsuranceGreen } from "../../common/svg";

import insurance_polish from "../../../static/images/svg/insurance-polish.svg";

const Insurance = ({ insSupport, openDetailIns, activeIns, disabled, isSD }) => {
	return (
		<>
			{insSupport === 1 ? (
				<div
					className={`insurance success ${disabled ? "pointer-none" : "cardetail"}`}
					onClick={!disabled ? openDetailIns : null}>
					{disabled ? <InsuranceGreen /> : <img loading="lazy" src={insurance_polish} />}
					<div className="content">
						<p>Bảo hiểm thuê xe {InsBy[activeIns]}</p>
						{!disabled && (
							<>
								{isSD ? (
									<p className="note">
										Chuyến đi có mua bảo hiểm. Khách thuê bồi thường tối đa 2.000.000 VNĐ trong trường hợp có sự cố
										ngoài ý muốn.
									</p>
								) : (
									<p className="note">
										An tâm hơn với gói bảo hiểm dành riêng các hành trình thuê xe có tài xế trên Mioto.
									</p>
								)}
								<p className="desc">
									<a className="info">Xem chi tiết</a>
								</p>
							</>
						)}
					</div>
				</div>
			) : (
				<div className="insurance disable">
					<div className="wrap-svg">
						<InsuranceBlack />
					</div>
					<div className="content">
						<p>Xe không hỗ trợ bảo hiểm</p>
					</div>
				</div>
			)}
		</>
	);
};

export default Insurance;
